import { combineReducers } from "redux";

import  order from "../features/admin/order_management/order/Slice"

const products = combineReducers({
  
  order: order,
});

export default products;
